import { handleActions } from 'redux-actions';
import actionTypes from './pageviewActionType';

const initState = {
  ids: [],
  byIds: {},
  current: null,
  loading: false
};

export default handleActions({

  [actionTypes.PAGEVIEW_EVENT_CREATE]: (state, payload) => {
    return {
      ...state,
      loading: true
    };
  },

  [actionTypes.PAGEVIEW_EVENT_CREATED]: (state, { payload }) => {
    const event = payload.data;
    return {
      ...state,
      current: null,
      loading: false,
      ids: [...state.ids, event.id],
      byIds: {
        ...state.byIds,
        [event.id]: {
          ...event,
          content: JSON.parse(event.content)
        }
      }
    };
  },

  [actionTypes.PAGEVIEW_EVENT_FETCHING_EVENTS]: (state, { payload }) => {
    return {
      ...state,
      loading: true
    };
  },

  [actionTypes.PAGEVIEW_EVENT_FETCH_EVENTS_SUCCESS]: (state, { payload }) => {
    let ids = [];
    const byIds = payload.events.reduce((acc, val) => {
      acc[val.id] = {
        ...val,
        content: JSON.parse(val.content)
      };
      ids.push(val.id);
      return acc;
    }, {});
    return {
      ...state,
      loading: false,
      byIds,
      ids
    };
  },

  [actionTypes.PAGEVIEW_EVENT_DELETED]: (state, { payload }) => {
    const index = state.ids.findIndex(item => item === payload.id);
    const newIds = [...state.ids.slice(0, index), ...state.ids.slice(index + 1)];
    const {[payload.id]: deleted, ...newByIds} = state.byIds;
    return {
      ...state,
      ids: newIds,
      byIds: newByIds
    };
  },

  [actionTypes.PAGEVIEW_EVENT_UPDATE_NEW]: (state, { payload }) => {
    const { inputs, operators } = payload;
    return {
      ...state,
      current: {
        inputs,
        operators
      }
    };
  }

}, initState);



/** WEBPACK FOOTER **
 ** ./src/redux/modules/pageview/pageview.js
 **/